
const BillingPlanDetails = ({
    credits,
    planDetails,
}) => {
    
    return (
        
        <div className="card card-compact bg-base-200 text-base-content">
            
            <div className="card-body">
                
                <p>Plan Details: <b>{planDetails}</b></p>
                <p>Account Balance: <b>${(credits.user ?? 0).toFixed(2)}</b></p>
            
            </div>
        
        </div>
        
    )
    
}

export default BillingPlanDetails
